export default __webpack_public_path__ + "static/media/browserconfig.337af024.xml";